import dayjs from "dayjs";

export const AUTH_MODULES = [
	{
		name: 'Admin Campaigns',
		path: 'admin/campaigns',
		visible: true,
		all: false,
	},
	{ name: 'Billing', path: 'admin/billing', visible: true, all: false },
	{
		name: 'Employee Users',
		path: 'admin/employee-users',
		visible: true,
		all: false,
	},
	{
		name: 'Client Users',
		path: 'admin/client-users',
		visible: true,
		all: false,
	},
	{ name: 'QC Control', path: 'admin/leads', visible: true, all: false },
	{
		name: 'Forecast Range',
		path: 'admin/forecast-range',
		visible: true,
		all: false,
	},
	{
		name: 'Forecast Month',
		path: 'admin/forecast-month',
		visible: true,
		all: false,
	},
	{
		name: 'Forecasst Week',
		path: 'admin/forecast-week',
		visible: true,
		all: false,
	},
	{
		name: 'Black Out Days',
		path: 'admin/black-out-days',
		visible: true,
		all: false,
	},
	{
		name: 'Reschedule Leads',
		path: 'admin/reschedule-leads',
		visible: true,
		all: false,
	},
	{
		name: 'Replacement Leads',
		path: 'admin/replacement-leads',
		visible: true,
		all: false,
	},
	{
		name: 'Customer Feedback',
		path: 'admin/customer-feedback',
		visible: true,
		all: false,
	},
	{
		name: 'Report Feedback',
		path: 'admin/report-feedback',
		visible: true,
		all: false,
	},
	{
		name: 'Login History',
		path: 'admin/history-login',
		visible: true,
		all: false,
	},
	{ name: 'Reports', path: 'admin/reports', visible: true, all: false },
	{
		name: 'Employee Reports',
		path: 'admin/employee-reports',
		visible: true,
		all: false,
	},
	{
		name: 'Lead Report',
		path: 'admin/lead-report',
		visible: true,
		all: false,
	},
	{ name: 'Dashboard', path: 'admin/dashboard', visible: true, all: false },
	{ name: 'Edit Users', path: 'admin/user-edit', visible: true, all: false },
	{
		name: 'Upload Prospects',
		path: 'admin/upload-prospects',
		visible: true,
		all: false,
	},
	{
		name: 'Edit Campaign',
		path: 'admin/campaign-edit',
		visible: true,
		all: false,
	},
	{ name: 'Payments', path: 'admin/payments', visible: true, all: false },
	{
		name: 'Call Report',
		path: 'admin/call-report',
		visible: true,
		all: false,
	},
	{
		name: 'Caller Overview',
		path: 'admin/caller-overview',
		visible: true,
		all: false,
	},
	{
		name: 'Dispo Report',
		path: 'admin/dispo-report',
		visible: true,
		all: false,
	},

	{
		name: 'Caller Campaigns',
		path: 'caller/campaigns',
		visible: true,
		all: false,
	},
	{ name: 'Search', path: 'caller/search', visible: true, all: false },
	{ name: 'DB Reset', path: 'caller/dbreset', visible: true, all: false },
	{ name: 'Dispos', path: 'caller/dispo', visible: true, all: false },
	{
		name: 'Calling View',
		path: 'caller/lead-profile',
		visible: true,
		all: false,
	},

	{
		name: 'Customer Leads',
		path: 'customer/leads',
		visible: true,
		all: false,
	},
	{
		name: 'Customer Calendar',
		path: 'customer/calendar',
		visible: true,
		all: false,
	},
	{
		name: 'Customer Black Out Days',
		path: 'customer/black-out-days',
		visible: true,
		all: false,
	},
	{
		name: 'Customer Account Review',
		path: 'customer/account-review',
		visible: true,
		all: false,
	},

	{
		name: 'Developer Options',
		path: 'developer/options',
		visible: true,
		all: false,
	},
	{ name: 'Add Campaign', path: 'campaign-add', visible: true, all: false },
	{
		name: 'Edit Lead',
		path: 'lead-edit/:selectedLead',
		visible: true,
		all: false,
	},
	{ name: 'Login', path: 'login', visible: false, all: false },
	{
		name: 'Campaign Calendar',
		path: 'campaign-calendar/:id',
		visible: true,
		all: false,
	},
	{
		name: 'All Campaigns Calendar',
		path: 'all-campaign-calendar',
		visible: true,
		all: false,
	},
	{ name: 'Default', path: '', visible: false, all: true },
	{
		name: 'Not Authorized',
		path: 'not-authorized',
		visible: true,
		all: false,
	},
];

// TODO: USE ONE OF THE TWO TIME ZONES
export const TIME_ZONES = [
	{
		name: 'ALASKA DAYLIGHT TIME UTC - 8',
		shortName: 'AKDT',
	},
	{
		name: 'ALASKA TIME UTC - 9',
		shortName: 'AKST',
	},
	{
		name: 'ATLANTIC STANDARD TIME	UTC - 4',
		shortName: 'AST',
	},
	{
		name: 'CENTRAL DAYLIGHT TIME UTC - 5',
		shortName: 'CDT',
	},
	{
		name: 'CENTRAL STANDARD TIME UTC - 6',
		shortName: 'CST',
	},
	{
		name: 'EASTERN DAYLIGHT TIME UTC - 4',
		shortName: 'EDT',
	},
	{
		name: 'EASTERN STANDARD TIME UTC - 5',
		shortName: 'EST',
	},
	{
		name: 'HAWAII-ALEUTIAN DAYLIGHT TIME UTC - 9',
		shortName: 'HADT',
	},
	{
		name: 'HAWAII-ALEUTIAN STANDARD TIME	UTC - 10',
		shortName: 'HAST',
	},
	{
		name: 'HAWAII STANDARD TIME UTC - 10',
		shortName: 'HST',
	},
	{
		name: 'MOUNTAIN DAYLIGHT TIME	UTC - 6',
		shortName: 'MDT',
	},
	{
		name: 'MOUNTAIN STANDARD TIME	UTC - 7',
		shortName: 'MST',
	},
	{
		name: 'PACIFIC DAYLIGHT TIME UTC - 7',
		shortName: 'PDT',
	},
	{
		name: 'PACIFIC STANDARD TIME UTC - 8',
		shortName: 'PST',
	},
];

export const APPT_TYPES = [
	{
		id: 1,
		name: 'face_to_face',
		description: 'Face to Face',
	},
	{
		id: 2,
		name: 'phone',
		description: 'Phone',
	},
	{
		id: 3,
		name: 'zoom',
		description: 'Zoom Meeting',
	},
];

export const INDUSTRIES = [
		{
			id: 1,
			name: '401k',
			description: '401k',
		},
		{
			id: 2,
			name: 'group_health',
			description: 'Group Health',
		},
		{
			id: 3,
			name: 'supplemental',
			description: 'Supplemental',
		},
		{
			id: 4,
			name: 'financial_wellness',
			description: 'Financial Wellness',
		},
		{
			id: 5,
			name: 'peo',
			description: 'PEO',
		},
		{
			id: 6,
			name: 'wc',
			description: "Worker's Comp",
		},
		{
			id: 7,
			name: 'commercial_insurance',
			description: 'Comercial Ins',
		},
		{
			id: 8,
			name: 'prospecting',
			description: 'Prospecting',
		},
		{
			id: 9,
			name: 'merchant_services',
			description: 'Merchant Services',
		},
		{
			id: 10,
			name: 'tax_savings',
			description: 'Tax Savings',
		},
		{
			id: 11,
			name: 'payroll',
			description: 'Payroll',
		},
		{
			id: 12,
			name: 'hro',
			description: 'HRO',
		},
		{
			id: 13,
			name: 'other',
			description: 'Other',
		},
	];

export const CRITERIA_TYPES = [
	{ description: 'Employee Size', selected: false },
	{ description: 'Asset Size', selected: false },
	{ description: 'Plan Particpants', selected: false },
	{ description: 'State', selected: false },
	{ description: 'Zip Code', selected: false },
];

export const CAMPAIGN_EDIT_MENU = [
	{
		text: 'Basic',
		tab_name: 'basic',
		icon: 'fa fa-address-card-o',
	},
	{
		text: 'Criteria',
		tab_name: 'criteria',
		icon: 'fa fa-table',
	},
	{
		text: 'Call sheet',
		tab_name: 'call_sheet',
		icon: 'fa fa-file-text-o',
	},
	{
		text: 'Dispo Log',
		tab_name: 'log',
		icon: 'fa fa-book',
	},
	{
		text: 'Stats',
		tab_name: 'stats',
		icon: 'fa fa-bar-chart',
	},
	{
		text: 'Calendar',
		tab_name: 'calendar',
		icon: 'fa fa-calendar',
	},
	{
		text: 'Contract Rules',
		tab_name: 'contract_rules',
		icon: 'fa fa-usd',
	},
	{
		text: 'Assigned Users',
		tab_name: 'Assigned_users',
		icon: 'fa fa-users',
	},
];

export const MONTHS = [
	{
		fullName: 'January',
		shortName: 'Jan',
		number: '01',
	},
	{
		fullName: 'February',
		shortName: 'Feb',
		number: '02',
	},
	{
		fullName: 'March',
		shortName: 'Mar',
		number: '03',
	},
	{
		fullName: 'April',
		shortName: 'Apr',
		number: '04',
	},
	{
		fullName: 'May',
		shortName: 'May',
		number: '05',
	},
	{
		fullName: 'June',
		shortName: 'Jun',
		number: '06',
	},
	{
		fullName: 'July',
		shortName: 'Jul',
		number: '07',
	},
	{
		fullName: 'Augost',
		shortName: 'Aug',
		number: '08',
	},
	{
		fullName: 'September',
		shortName: 'Sep',
		number: '09',
	},
	{
		fullName: 'October',
		shortName: 'Oct',
		number: '10',
	},
	{
		fullName: 'November',
		shortName: 'Nov',
		number: '11',
	},
	{
		fullName: 'December',
		shortName: 'Dec',
		number: '12',
	},
];

export const STATES = [
	{ name: 'Alabama', shortName: 'AL' },
	{ name: 'Alaska', shortName: 'AK' },
	{ name: 'Arizona', shortName: 'AZ' },
	{ name: 'Arkansas', shortName: 'AR' },
	{ name: 'California', shortName: 'CA' },
	{ name: 'Colorado', shortName: 'CO' },
	{ name: 'Connecticut', shortName: 'CT' },
	{ name: 'Delaware', shortName: 'DE' },
	{ name: 'District of Columbia', shortName: 'DC' },
	{ name: 'Florida', shortName: 'FL' },
	{ name: 'Georgia', shortName: 'GA' },
	{ name: 'Hawaii', shortName: 'HI' },
	{ name: 'Idaho', shortName: 'ID' },
	{ name: 'Illinois', shortName: 'IL' },
	{ name: 'Indiana', shortName: 'IN' },
	{ name: 'Iowa', shortName: 'IA' },
	{ name: 'Kansas', shortName: 'KS' },
	{ name: 'Kentucky', shortName: 'KY' },
	{ name: 'Louisiana', shortName: 'LA' },
	{ name: 'Maine', shortName: 'ME' },
	{ name: 'Maryland', shortName: 'MD' },
	{ name: 'Massachusetts', shortName: 'MA' },
	{ name: 'Michigan', shortName: 'MI' },
	{ name: 'Minnesota', shortName: 'MN' },
	{ name: 'Mississippi', shortName: 'MS' },
	{ name: 'Missouri', shortName: 'MO' },
	{ name: 'Montana', shortName: 'MT' },
	{ name: 'Nebraska', shortName: 'NE' },
	{ name: 'Nevada', shortName: 'NV' },
	{ name: 'New Hampshire', shortName: 'NH' },
	{ name: 'New Jersey', shortName: 'NJ' },
	{ name: 'New Mexico', shortName: 'NM' },
	{ name: 'New York', shortName: 'NY' },
	{ name: 'North Carolina', shortName: 'NC' },
	{ name: 'North Dakota', shortName: 'ND' },
	{ name: 'Ohio', shortName: 'OH' },
	{ name: 'Oklahoma', shortName: 'OK' },
	{ name: 'Oregon', shortName: 'OR' },
	{ name: 'Pennsylvania', shortName: 'PA' },
	{ name: 'Rhode Island', shortName: 'RI' },
	{ name: 'South Carolina', shortName: 'SC' },
	{ name: 'South Dakota', shortName: 'SD' },
	{ name: 'Tennessee', shortName: 'TN' },
	{ name: 'Texas', shortName: 'TX' },
	{ name: 'Utah', shortName: 'UT' },
	{ name: 'Vermont', shortName: 'VT' },
	{ name: 'Virginia', shortName: 'VA' },
	{ name: 'Washington', shortName: 'WA' },
	{ name: 'West Virginia', shortName: 'WV' },
	{ name: 'Wisconsin', shortName: 'WI' },
	{ name: 'Wyoming', shortName: 'WY' },
	{ name: 'Alberta', shortName: 'AB' },
	{ name: 'British Columbia', shortName: 'BC' },
	{ name: 'Manitoba', shortName: 'MB' },
	{ name: 'New Brunswick', shortName: 'NB' },
	{ name: 'Newfoundland and Labrador', shortName: 'NL' },
	{ name: 'Nova Scotia', shortName: 'NS' },
	{ name: 'Northwest Territories', shortName: 'NT' },
	{ name: 'Nunavut', shortName: 'NU' },
	{ name: 'Ontario', shortName: 'ON' },
	{ name: 'Prince Edward Island', shortName: 'PE' },
	{ name: 'Quebec', shortName: 'QC' },
	{ name: 'Saskatchewan', shortName: 'SK' },
	{ name: 'Yukon', shortName: 'YT' },
];

export const TITLES = [
	'Owner',
	'Principal',
	'Chairman',
	'Member',
	'Managing Member',
	'Board Member',
	'Partner',
	'Senior Partner',
	'Junior Partner',
	'President',
	'Vice President',
	'Senior Vice President',
	'Junior Vice President',
	'Executive Vice President',
	'Executive',
	'Manufacturing Executive',
	'Operations Executive',
	'Chief Executive Officer',
	'Chief Financial Officer',
	'Chief Technology Officer',
	'Chief Information Officer',
	'Chief Operating Officer',
	'Chief Administrative Officer',
	'Controller',
	'Director',
	'Executive Director',
	'Administrator',
	'Administrative Assistant',
	'Manager',
	'General Manager',
	'Assistant Manager',
	'Site Manager',
	'Plant Manager',
	'Practice Manager',
	'Operations Manager',
	'Business Manager',
	'Sales Manager',
	'Sales Executive',
	'IT Manager',
	'IT Executive',
	'IT Assistant',
	'Office Manager',
	'Office Administrator',
	'Office Assistant',
	'Finance Manager',
	'Finance Executive',
	'Accountant',
	'Accounting Manager',
	'Accounting Specialist',
	'Billing Manager',
	'Billing Specialist',
	'Bookkeeper',
	'Benefits Manager',
	'Benefits Director',
	'Benefits Coordinator',
	'Benefits Specialist',
	'Benefits Administrator',
	'Senior Benefits Administrator',
	'Junior Benefits Administrator',
	'Payroll Manager',
	'Payroll Administrator',
	'Payroll Clerk',
	'Payroll Specialist',
	'Payroll Assistant',
	'HR Manager',
	'HR Director',
	'HR Coordinator',
	'HR Administrator',
	'HR Generalist',
	'HR Specialist',
	'HR Assistant',
	'Other',
];

export const QC_THEADS = [
	{
		text: 'Id',
		key: 'id',
		visible: true,
		type: 'number',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-5',
	},
	{
		text: 'Creation date',
		key: 'lead_creation',
		visible: true,
		type: 'mediumDate',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-15',
	},
	{
		text: 'Agent',
		key: 'generated_by',
		visible: true,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-10',
	},
	{
		text: 'Appt Date',
		key: 'date_generated',
		visible: true,
		type: 'medium',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-15',
	},
	{
		text: 'Time Zone',
		key: 'time_zone',
		visible: false,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: '',
	},
	{
		text: 'Phone',
		key: 'primary_phone',
		visible: true,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-10',
	},
	{
		text: 'Prospect',
		key: 'prospect_company',
		visible: true,
		type: 'string',
		order: '',
		align: 'left',
		cell_class: [],
		icon: 'fa fa-hand-pointer-o',
		width: 'tcol-25',
	},
	{
		text: 'Status',
		key: 'replacement_status',
		visible: true,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [
			{
				value: 'Approved',
				class: 'bg-success',
				operator: '==',
			},
		],
		width: 'tcol-25',
	},
	{
		text: 'Replaced by',
		key: 'replaced_by',
		visible: true,
		type: 'string',
		order: '',
		align: 'center',
		width: 'tcol-25',
	},
	{
		text: 'Replaced for',
		key: 'replace_for',
		visible: false,
		type: 'string',
		order: '',
		align: 'center',
		width: 'tcol-25',
	},
	{
		text: 'Meet Type',
		key: 'meet_type',
		visible: true,
		type: 'HTML',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-25',
	},
	{
		text: 'Difficulty',
		key: 'difficult',
		visible: true,
		type: 'HTML',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-25',
	},
	{
		text: 'Qualified',
		key: 'calificado',
		visible: true,
		type: 'string',
		order: '',
		align: 'center',
		width: 'tcol-25',
	},
	{
		text: 'Campaign',
		key: 'campaign_name',
		visible: true,
		type: 'HTML',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-25',
	},
	{
		text: 'Billed',
		key: 'payed',
		visible: true,
		type: 'HTML',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-25',
	},
	{
		text: 'Confirmation',
		key: 'confirmation',
		visible: true,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-25',
	},
	{
		text: 'Prospect Name',
		key: 'prospect_name',
		visible: false,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-15',
	},
	{
		text: 'City',
		key: 'city',
		visible: false,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: '',
	},
	{
		text: 'State',
		key: 'state',
		visible: false,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: '',
	},
	{
		text: 'Zip',
		key: 'zip',
		visible: false,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: '',
	},
	{
		text: 'Email',
		key: 'primary_email',
		visible: false,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: '',
	},
	{
		text: 'Employee Size',
		key: 'employee_size',
		visible: false,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: '',
	},
	{
		text: 'Time In status',
		key: 'change_date',
		visible: false,
		type: 'dateAgo',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-20',
	},
];

export const RESCHEDULE_THEADS = [
	{
		text: 'Id',
		key: 'id',
		visible: true,
		type: 'number',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-15',
	},
	{
		text: 'Lead Creation',
		key: 'lead_creation',
		visible: false,
		type: 'mediumDate',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-15',
	},
	{
		text: 'Appt Date',
		key: 'date_generated',
		visible: true,
		type: 'short',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-20',
	},
	{
		text: 'Phone',
		key: 'primary_phone',
		visible: true,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-15',
	},
	{
		text: 'Email',
		key: 'primary_email',
		visible: false,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: '',
	},
	{
		text: 'Prospect',
		key: 'prospect_company',
		visible: true,
		type: 'string',
		order: '',
		align: 'left',
		cell_class: [],
		icon: 'fa fa-hand-pointer-o',
		width: 'tcol-25',
	},
	{
		text: 'Status',
		key: 'replacement_status',
		visible: false,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [
			{
				value: 'Approved',
				class: 'bg-success',
				operator: '==',
			},
		],
		width: 'tcol-25',
	},
	{
		text: 'Campaign',
		key: 'campaign_name',
		visible: true,
		type: 'HTML',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-25',
	},
	{
		text: 'Prospect Name',
		key: 'prospect_name',
		visible: false,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-15',
	},
	{
		text: 'City',
		key: 'city',
		visible: false,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: '',
	},
	{
		text: 'State',
		key: 'state',
		visible: false,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: '',
	},
	{
		text: 'Zip',
		key: 'zip',
		visible: false,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: '',
	},
	{
		text: 'Employee Size',
		key: 'employee_size',
		visible: false,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: '',
	},
	{
		text: 'Time In status',
		key: 'change_date',
		visible: true,
		type: 'dateAgo',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-20',
	},
];

export const FYI_THEADS = [
	{
		text: 'ID',
		key: 'prospect',
		visible: true,
		type: 'number',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-5',
	},
	{
		text: 'Prospect Name',
		key: 'prospect_name',
		visible: true,
		type: 'string',
		order: '',
		align: 'left',
		cell_class: [],
		width: '',
	},
	{
		text: 'Phone',
		key: 'prospect_phone',
		visible: true,
		type: 'number',
		order: '',
		align: 'center',
		cell_class: [],
		width: '',
	},
	{
		text: 'Campaign Name',
		key: 'campaign_name',
		visible: true,
		type: 'string',
		order: '',
		align: 'left',
		cell_class: [],
		width: 'tcol-15',
	},
	{
		text: 'Created',
		key: 'created',
		visible: true,
		type: 'mediumDate',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-10',
	},
	{
		text: 'Callback Date',
		key: 'callback_date',
		visible: true,
		type: 'mediumDate',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-10',
	},
	{
		text: 'Notes',
		key: 'notes',
		visible: true,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: '',
	},
	{
		text: 'Called',
		key: 'called',
		visible: true,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: '',
	},
];

export const DATE_PICKER_RANGE_PAST = {
	'Last Week': [
		dayjs().day(0).subtract(7, 'days').format('YYYY-MM-DD'),
		dayjs().day(6).subtract(7, 'days').format('YYYY-MM-DD'),
	],
	'Last month': [
		dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
		dayjs().format('YYYY-MM-DD'),
	],
	'Past 2 months': [
		dayjs().subtract(2, 'month').format('YYYY-MM-DD'),
		dayjs().format('YYYY-MM-DD'),
	],
	'Past 3 months': [
		dayjs().subtract(3, 'month').format('YYYY-MM-DD'),
		dayjs().format('YYYY-MM-DD'),
	],
	'Last year': [
		dayjs().startOf('year').subtract(1, 'year').format('YYYY-MM-DD'),
		dayjs().endOf('year').subtract(1, 'year').format('YYYY-MM-DD'),
	],
};

// TODO: Change the constants STATEs across the system
export const STATES_SMALL = [
	{ name: 'Alabama', smallName: 'AL' },
	{ name: 'Alaska', smallName: 'AK' },
	{ name: 'Arizona', smallName: 'AZ' },
	{ name: 'Arkansas', smallName: 'AR' },
	{ name: 'California', smallName: 'CA' },
	{ name: 'Colorado', smallName: 'CO' },
	{ name: 'Connecticut', smallName: 'CT' },
	{ name: 'Delaware', smallName: 'DE' },
	{ name: 'Florida', smallName: 'FL' },
	{ name: 'Georgia', smallName: 'GA' },
	{ name: 'Hawaii', smallName: 'HI' },
	{ name: 'Idaho', smallName: 'ID' },
	{ name: 'Illinois', smallName: 'IL' },
	{ name: 'Indiana', smallName: 'IN' },
	{ name: 'Iowa', smallName: 'IA' },
	{ name: 'Kansas', smallName: 'KS' },
	{ name: 'Kentucky', smallName: 'KY' },
	{ name: 'Louisiana', smallName: 'LA' },
	{ name: 'Maine', smallName: 'ME' },
	{ name: 'Maryland', smallName: 'MD' },
	{ name: 'Massachusetts', smallName: 'MA' },
	{ name: 'Michigan', smallName: 'MI' },
	{ name: 'Minnesota', smallName: 'MN' },
	{ name: 'Mississippi', smallName: 'MS' },
	{ name: 'Missouri', smallName: 'MO' },
	{ name: 'Montana', smallName: 'MT' },
	{ name: 'Nebraska', smallName: 'NE' },
	{ name: 'Nevada', smallName: 'NV' },
	{ name: 'New Hampshire', smallName: 'NH' },
	{ name: 'New Jersey', smallName: 'NJ' },
	{ name: 'New Mexico', smallName: 'NM' },
	{ name: 'New York', smallName: 'NY' },
	{ name: 'North Carolina', smallName: 'NC' },
	{ name: 'North Dakota', smallName: 'ND' },
	{ name: 'Ohio', smallName: 'OH' },
	{ name: 'Oklahoma', smallName: 'OK' },
	{ name: 'Oregon', smallName: 'OR' },
	{ name: 'Pennsylvania', smallName: 'PA' },
	{ name: 'Rhode Island', smallName: 'RI' },
	{ name: 'South Carolina', smallName: 'SC' },
	{ name: 'South Dakota', smallName: 'SD' },
	{ name: 'Tennessee', smallName: 'TN' },
	{ name: 'Texas', smallName: 'TX' },
	{ name: 'Utah', smallName: 'UT' },
	{ name: 'Vermont', smallName: 'VT' },
	{ name: 'Virginia', smallName: 'VA' },
	{ name: 'Washington', smallName: 'WA' },
	{ name: 'West Virginia', smallName: 'WV' },
	{ name: 'Wisconsin', smallName: 'WI' },
	{ name: 'Wyoming', smallName: 'WY' }
  ];

export const DAYS = Array.from({ length: 31 }, (v, k) => (k+1) < 10 ? '0' + (k+1) : (k+1).toString());

// TODO: Add more Years after 2027
export const YEARS = ['2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026', '2026', '2027'];

export const SOURCES = [
	{ id: 1, name: 'T3direct Marketing' },
	{ id: 2, name: '401k Depot'},
	{ id: 3, name: 'Toplead'},
];

export const CONTRACT_TYPES = [
	{ id: 1, name: 'Normal' },
	{ id: 2, name: 'Reserve'},
	{ id: 3, name: 'Hourly'}
]

export const PERIODICITY = [
		{ value: 'daily', label: 'Daily' , code : 'D'},
		{ value: 'weekly', label: 'Weekly' , code : 'W'},
		{ value: 'monthly', label: 'Monthly' , code : 'M'},
		{ value: 'quarterly', label: 'Quarterly' , code : 'Q'},
		{ value: 'yearly', label: 'Yearly' , code : 'Y'}
]

export const QC_COLUMNS = [
		{
			name: "ID",
			visible: true,
			prop: "id",
		},
		{
			name: "Creation Date",
			visible: true,
			prop: "lead_creation",
		},
		{
			name: "Agent",
			visible: true,
			prop: "generated_by",
		},
		{
			name: "Appt Date",
			visible: true,
			prop: "date_generated",
		},
		{
			name: "Time Zone",
			visible: false,
			prop: "time_zone",
		},
		{
			name: "Phone",
			visible: true,
			prop: "primary_phone",
		},
		{
			name: "Prospect",
			visible: true,
			prop: "prospect_company",
		},
		{
			name: "Prospect Name",
			visible: false,
			prop: "prospect_name",
		},
		{
			name: "Status",
			visible: true,
			prop: "replacement_status",
		},
		{
			name: "Replaced By",
			visible: false,
			prop: "replaced_by",
		},
		{
			name: "Replace For",
			visible: false,
			prop: "replace_for",
		},
		{
			name: "Meet Type",
			visible: true,
			prop: "meet_type",
		},
		{
			name: "Difficulty",
			visible: true,
			prop: "difficult",
		},
		{
			name: "Qualified",
			visible: true,
			prop: "calificado",
		},
		{
			name: "Campaign Name",
			visible: true,
			prop: "campaign_name",
		},
		{
			name: "Billed",
			visible: true,
			prop: "payed",
		},
		{
			name: "Free Type",
			visible: true,
			prop: "free_type",
		},
		{
			name: "Confirmation",
			visible: true,
			prop: "confirmation",
		},
		{
			name: "City",
			visible: false,
			prop: "city",
		},
		{
			name: "State",
			visible: false,
			prop: "state",
		},
		{
			name: "Zip",
			visible: false,
			prop: "zip",
		},
		{
			name: "Primary Email",
			visible: false,
			prop: "primary_email",
		},
		{
			name: "Employee Size",
			visible: false,
			prop: "employee_size",
		},
		{
			name: "Change Date",
			visible: false,
			prop: "change_date",
		},
	];

export const PROSPECTS_TABLE_POSSIBLE_NAMES: any = {
		primary_phone: ['Sponsor Phone','primary_phone', 'phone'],
		alt_phone: ['alt_phone', 'secondary_phone'],
		company_name: ['Sponsor Name','company_name', 'business_name', 'company name', 'company'],
		address_1: ['Sponsor Street', 'address_1', 'business_address_1', 'address', 'address 1'],
		address_2: ['Sponsor Street 2', 'address_2', 'business_address_2', 'address 2'],
		city: ['Sponsor City','city', 'business_city'],
		state: ['Sponsor State', 'state', 'business_state'],
		province: ['province', 'business_province'],
		zip: 	['Sponsor Zip','zip', 'business_zip', 'zip_code', 'zip code'],
		first_name: ['Sponsor Contact 01 First Name', 'first_name', 'business_first_name', 'first name', 'first'],
		last_name: ['Sponsor Contact 01 Last Name', 'last_name', 'business_last_name', 'last name', 'last'],
		alt_contact: ['Sponsor Contact 02 First Name','alt_contact', 'business_alt_contact', 'alt contact', 'alt'],
		title: ['Sponsor Contact 01 Title','title', 'business_title'],
		direct_line: ['direct_line', 'business_direct_line', 'direct line', 'direct'],
		ext: ['ext', 'business_ext', 'ext'],
		mobile_phone: ['mobile_phone', 'business_mobile_phone', 'mobile phone', 'mobile'],
		primary_email: ['Sponsor Contact Email','primary_email', 'business_primary_email', 'email', 'email address', 'email1', 'email 1','primary email'],
		alt_email: ['alt_email', 'business_alt_email', 'email2', 'email 2', 'alternative email'],
		employee_size: ['Total Employees','employee_size', 'business_employee_size', 'employee size', 'employee'],
		EIN: ['Sponsor EIN', 'EIN', 'business_EIN', 'ein', 'ein number'],
		website_url: ['Sponsor Website','website_url', 'business_website_url', 'website url', 'website'],
		business_code: ['Business (NAICS) Code','business_code', 'business_code', 'business code', 'business'],
		business_code_description: ['business_code_description', 'business_code_description', 'business code description', 'business'],
		country_code: ['country_code', 'business_country_code', 'country code', 'country'],
		annual_revenue: ['annual_revenue', 'business_annual_revenue', 'annual revenue'],
		plan_assets: ['Sponsor Total Assets', 'plan_assets', 'business_plan_assets', 'plan assets'],
		plan_participants: ['Participants: Active Total', 'plan_participants', 'business_plan_participants', 'plan participants', 'participants'],
		provider_1: ['Plan Name','provider_1', 'business_provider_1', 'provider 1', 'provider'],
		provider_2: ['provider_2', 'business_provider_2', 'provider 2', 'provider 2'],
		renewal_month_1: ['Plan Renewal Month (1-12)', 'renewal_month_1', 'business_renewal_month_1' , 'renewal month', 'renewal'],
		renewal_year_1: ['Plan Year End Date','renewal_year_1', 'business_renewal_year_1'],
		renewal_month_2: ['renewal_month_2', 'business_renewal_month_2'],
		renewal_year_2: ['renewal_year_2', 'business_renewal_year_2'],
		additional_info: ['additional_info', 'business_additional_info'],
	};

	export const PROSPECT_COLUMNS: any =  [
		{ name: '#', prop: 'index', visible: true },
		{ name: 'Company Name', prop: 'company_name', visible: true },
		{ name: 'First Name', prop: 'first_name', visible: true },
		{ name: 'Last Name', prop: 'last_name', visible: true },
		{ name: 'Primary Phone', prop: 'primary_phone', visible: true },
		{ name: 'Primary Email', prop: 'primary_email', visible: true },
		{ name: 'Title', prop: 'title', visible: true },
		{ name: 'City', prop: 'city', visible: true },
		{ name: 'State', prop: 'state', visible: true },
		{ name: 'Zip', prop: 'zip', visible: true },
		{ name: 'Employee Size', prop: 'employee_size', visible: true },
		{ name: 'Annual Revenue', prop: 'annual_revenue', visible: true },
		{ name: 'Plan Assets', prop: 'plan_assets', visible: true },
		{ name: 'Plan Participants', prop: 'plan_participants', visible: true },
		{ name: 'Provider 1', prop: 'provider_1', visible: false },
		{ name: 'Provider 2', prop: 'provider_2', visible: false },
		{ name: 'Renewal Month 1', prop: 'renewal_month_1', visible: false },
		{ name: 'Renewal Year 1', prop: 'renewal_year_1', visible: false },
		{ name: 'Alt Contact', prop: 'alt_contact', visible: false },
		{ name: 'Alt Phone', prop: 'alt_phone', visible: false },
		{ name: 'Alt Email', prop: 'alt_email', visible: false },
		{ name: 'Address 1', prop: 'address_1', visible: false },
		{ name: 'Address 2', prop: 'address_2', visible: false },
		{ name: 'Province', prop: 'province', visible: false },
		{ name: 'Direct Line', prop: 'direct_line', visible: false },
		{ name: 'Extension', prop: 'ext', visible: false },
		{ name: 'Mobile Phone', prop: 'mobile_phone', visible: false },
		{ name: 'EIN', prop: 'EIN', visible: false },
		{ name: 'Business Code', prop: 'business_code', visible: false },
		{ name: 'Business Code Description', prop: 'business_code_description', visible: false },
		{ name: 'Website URL', prop: 'website_url', visible: false },
		{ name: 'Country Code', prop: 'country_code', visible: false },
		{ name: 'Renewal Month 2', prop: 'renewal_month_2', visible: false },
		{ name: 'Renewal Year 2', prop: 'renewal_year_2', visible: false },
		{ name: 'Available Date', prop: 'available_date', visible: false },
		{ name: 'Last Dispo', prop: 'last_dispo', visible: false },
		{ name: 'Source', prop: 'source', visible: false },
		{ name: 'Active', prop: 'isActive', visible: false }
		];

	export const NO_RESULTS_PROSPECTS = [{
		"id": 0,
		"company_name": "No results",
		"EIN": "",
		"form_5500": "",
		"business_code": "",
		"business_code_description": "",
		"website_url": "",
		"country_code": "",
		"primary_phone": "",
		"alt_phone": "",
		"address_1": "",
		"address_2": "",
		"city": "",
		"state": "",
		"province": "",
		"zip": "",
		"first_name": "",
		"last_name": "",
		"alt_contact": "",
		"title": "",
		"direct_line": "",
		"ext": "",
		"mobile_phone": "",
		"primary_email": "",
		"alt_email": "",
		"employee_size": "",
		"annual_revenue": "",
		"plan_assets": "",
		"plan_participants": "",
		"provider_1": "",
		"provider_2": "",
		"renewal_month_1": "",
		"renewal_year_1": "",
		"renewal_month_2": "",
		"renewal_year_2": "",
		"additional_info": "",
		"available_date": "",
		"assigned_campaigns": "",
		"campaign_owner": ""
	}];

	export const LOGO_PDF = 'data:image/png;base64,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';

	export const LIFECYCLE_TYPES: { [key: number]: { label: string; colorClass: string; iconClass: string } } = {
  1:  { label: 'Lead Creation',           colorClass: 'lc-info',    iconClass: 'ri-add-circle-line' },
  2:  { label: 'Approved',             colorClass: 'lc-success', iconClass: 'ri-checkbox-circle-line' },
  3:  { label: 'Denied',               colorClass: 'lc-danger',  iconClass: 'ri-close-circle-line' },
  4:  { label: 'Lead Confirmation',            colorClass: 'lc-success', iconClass: 'ri-shield-check-line' },
  5:  { label: 'Set to QC Call',             colorClass: 'lc-warning', iconClass: 'ri-phone-line' },
  6:  { label: 'Replacement Request',colorClass: 'lc-warning', iconClass: 'ri-arrow-go-forward-line' },
  7:  { label: 'Replacement Denied',   colorClass: 'lc-danger',  iconClass: 'ri-arrow-go-forward-line' },
  8:  { label: 'Replacement Approved', colorClass: 'lc-success', iconClass: 'ri-arrow-go-forward-line' },
  9:  { label: 'Reschedule Request',   colorClass: 'lc-warning', iconClass: 'ri-calendar-line' },
  10: { label: 'Reschedule Denied',    colorClass: 'lc-danger',  iconClass: 'ri-calendar-close-line' },
  11: { label: 'Reschedule Approved',  colorClass: 'lc-success', iconClass: 'ri-calendar-check-line' },
  13: { label: 'Lead Replaced',        colorClass: 'lc-info',    iconClass: 'ri-arrow-left-right-line' },
  14: { label: 'Lead Rescheduled',     colorClass: 'lc-info',    iconClass: 'ri-calendar-2-line' },
  15: { label: 'Fix',                  colorClass: 'lc-primary', iconClass: 'ri-tools-fill' },
  16: { label: 'Lead Unreplaced',      colorClass: 'lc-info',    iconClass: 'ri-arrow-go-back-line' },
};

/**
 * Mirrors the `ai_agents` table (LMS_api) — `id` is the numeric agent id the backend expects.
 * `key` is the internal roster key used throughout ai-agents.component.ts (see AiAgent.key in
 * ai-agents.roster.ts). Keep in sync with that table if agents are added, renamed, or removed.
 */
export const AI_AGENT_CATALOG = [
	{ id: 1, key: 'ivy', name: 'Ivy' },
	{ id: 2, key: 'warren', name: 'Warren' },
	{ id: 3, key: 'connor', name: 'Connor' },
	{ id: 4, key: 'sam', name: 'Sam' },
	{ id: 5, key: 'renee', name: 'Renée' },
	{ id: 6, key: 'parker', name: 'Parker' },
];



